import { GoalDirection } from './dataTypeOptions'

/**
 * Returns the meaning of a value based on a goal direction.
 *
 * Will return 'good' or 'bad' based on the target goal
 * direction provided.
 *
 * returns false if the value is not a number or if a direction
 * isn't provided.
 *
 */
export const getMeaningByGoalDirection = (
  direction?: GoalDirection,
  value?: unknown | number,
) => {
  if (typeof value !== 'number' || !direction) {
    return false
  }

  const operator = direction.match(/[<>]=?/)?.[0] ?? ''
  const numberString = direction.replace(operator, '')

  const threshold = numberString ? parseFloat(numberString) : 0

  if (isNaN(threshold)) {
    return 'good'
  }

  switch (operator) {
    case '<':
      return value < threshold ? 'good' : 'bad'
    case '<=':
      return value <= threshold ? 'good' : 'bad'
    case '>':
      return value > threshold ? 'good' : 'bad'
    case '>=':
      return value >= threshold ? 'good' : 'bad'
    default:
      return 'good'
  }
}
